import { Box, Typography } from '@mui/material';
import { IMessageChat } from '../../../interfaces/chat.ts';
import handleFormatFile from '../../../utils/handleFormatFile.tsx';

export default function Message({ message }: { message: IMessageChat }) {
	const type = handleFormatFile(message?.file ?? '');

	{
		/*todo fix shadow size*/
	}
	const style = `rounded-md flex flex-col gap-2 leading-6 py-2 px-4 ${message?.is_user_message ? 'rounded-tl-none text-grey-600 shadow' : 'rounded-tr-none bg-primary-main text-white'}`;

	// todo if change language how change rounded-tl to rounded-tr
	if (type === 'image') {
		return (
			<Box className={style}>
				<img src={message?.file} className={'max-h-72 max-w-72 rounded'} alt={message?.message} />
				<Typography>{message?.message}</Typography>
			</Box>
		);
	} else if (type === 'video') {
		return (
			<Box className={style}>
				<video src={message?.file} className={'h-72 w-72 rounded'} />
				<Typography>{message?.message}</Typography>
			</Box>
		);
	} else if (type === 'audio') {
		return (
			<Box className={style}>
				<audio controls>
					<source src={message?.file} />
				</audio>
				<Typography>{message?.message}</Typography>
			</Box>
		);
	}

	return (
		<Box className={style}>
			<Typography>{message?.message}</Typography>
		</Box>
	);
}
